import {
  GET_ALL_PENDING_POD_SUMMARY_AR_REQUEST,
  GET_ALL_PENDING_POD_SUMMARY_AR_SUCCESS, 
  GET_ALL_PENDING_POD_SUMMARY_AR_ERROR   
  } from "./types";
  import axios from "axios";
  import { BASEURL } from "../../constant/config.js";
  import moment from "moment";

  export const getPendingPodSummaryAr = (token, values) => (dispatch) => {
    let cleanedVal = values.customer === undefined ? null : values.customer.includes("'") ? values.customer.replace(/'/g, "''") : values.customer;
    dispatch({ type: GET_ALL_PENDING_POD_SUMMARY_AR_REQUEST });
    const newData = {
            ship_header_no: values.ship_no === undefined || values.ship_no === "" ? null : values.ship_no,
            order_header_no: values.order_no === undefined || values.order_no === "" ? null : values.order_no,
            date_from: moment(values.from_date).format("MM-DD-YYYY"),
            date_to: moment(values.to_date).format("MM-DD-YYYY"),
            reference_no: values.po_no === undefined || values.po_no === "" ?  null : values.po_no,
            customer: cleanedVal === undefined || cleanedVal === "" ? null : cleanedVal,
            sp_id: values.sale_person === "All" ? null : values.sale_person,
            region_id: ( values.region === "All" || values.region === undefined ) ? null : values.region.toString(),
            gender_id: values.gender === "All" ? null : values.gender,
            payment_term_id: values.terms === "All" ? null : values.terms,
            company_id: values.subsidary === "All" ? null : values.subsidary,
            status_id: values.status === undefined || values.status === "All" ? null : values.status,
            ship_status_id: values.ship_status === undefined || values.ship_status === "All" ? null : values.ship_status,
            location_id: values.location === undefined || values.location === "All" ? null : values.location
            
    };
    
    return axios({
      method: "POST",
      url: `${BASEURL}getAll/Omspodsummaryar`,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: newData,
    })
      .then((response) => {
        return dispatch({
          type: GET_ALL_PENDING_POD_SUMMARY_AR_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ALL_PENDING_POD_SUMMARY_AR_ERROR,
          payload: [],
        });
      });
  };
  